import { useState } from "react";
import { Spinner, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/styles/customTable.scss";
import useColumnResize from "../../hooks/useColumnResize";

const AddressesTable = ({ data, isLoading = false, onSortChange, onSelectionChange }) => {
  const [sortConfig, setSortConfig] = useState({ key: "Id", direction: "asc" });
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const navigate = useNavigate();
  const { getResizeProps } = useColumnResize();

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    const newSortConfig = { key, direction };
    setSortConfig(newSortConfig);
    onSortChange(newSortConfig);
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? "↑" : "↓";
    }
    return "";
  };

  const handleRowClick = (item) => {
    navigate(`/information/${item.id}`);
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    
    if (isChecked) {
      const allIds = items.map(item => item.id);
      setSelectedIds(allIds);
      onSelectionChange?.(allIds);
    } else {
      setSelectedIds([]);
      onSelectionChange?.([]);
    }
  };

  const handleCheckboxChange = (e, itemId) => {
    e.stopPropagation();
    const isChecked = e.target.checked;
    let newSelectedIds;

    if (isChecked) {
      newSelectedIds = [...selectedIds, itemId];
    } else {
      newSelectedIds = selectedIds.filter(id => id !== itemId);
      setSelectAll(false);
    }

    setSelectedIds(newSelectedIds);
    onSelectionChange?.(newSelectedIds);

    // Check if all items are selected to update selectAll state
    if (newSelectedIds.length === items.length && items.length > 0) {
      setSelectAll(true);
    }
  };

  const items = Array.isArray(data) ? data : [];

  return (
    <div>
      <Table
        responsive
        striped
        bordered
        hover
        size="sm"
        className="custom-table"
      >
        <thead>
          <tr>
            <th>
              <input 
                type="checkbox" 
                checked={selectAll}
                onChange={handleSelectAll}
              />
            </th>
            <th onClick={() => requestSort("terminalDr")} {...getResizeProps()}>
              DR {getSortArrow("terminalDr")}
            </th>
            <th onClick={() => requestSort("terminalEx")} {...getResizeProps()}>
              EX {getSortArrow("terminalEx")}
            </th>
            <th onClick={() => requestSort("postcode")} {...getResizeProps()}>
              Kod {getSortArrow("postcode")}
            </th>
            <th onClick={() => requestSort("type")} {...getResizeProps()}>
              Typ rekordu {getSortArrow("type")}
            </th>
            <th onClick={() => requestSort("province")} {...getResizeProps()}>
              Województwo {getSortArrow("province")}
            </th>
            <th onClick={() => requestSort("cityName")} {...getResizeProps()}>
              Miejscowość {getSortArrow("cityName")}
            </th>
            <th onClick={() => requestSort("streetName")} {...getResizeProps()}>
              Ulica {getSortArrow("streetName")}
            </th>
            <th onClick={() => requestSort("number")} {...getResizeProps()}>
              Nr domu {getSortArrow("number")}
            </th>
            <th onClick={() => requestSort("numberInt")} {...getResizeProps()}>
              Nr domu (całk.) {getSortArrow("numberInt")}
            </th>
            <th onClick={() => requestSort("buildingType")} {...getResizeProps()}>
              Typ {getSortArrow("buildingType")}
            </th>
            <th onClick={() => requestSort("exPn")} {...getResizeProps()}>
              EX_PN {getSortArrow("exPn")}
            </th>
            <th onClick={() => requestSort("drPn")} {...getResizeProps()}>
              DR_PN {getSortArrow("drPn")}
            </th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="13" className="text-center py-4">
                <Spinner animation="border" role="status" size="sm" className="me-2" />
                <span>Ładowanie danych...</span>
              </td>
            </tr>
          ) : items.length > 0 ? (
            items.map((item, index) => (
              <tr 
                key={`${item.id}-${index}`}
                onClick={() => handleRowClick(item)}
                style={{ 
                  cursor: "pointer",
                  transition: "background-color 0.2s ease"
                }}
                onMouseEnter={(e) => e.target.closest('tr').style.backgroundColor = '#f8f9fa'}
                onMouseLeave={(e) => e.target.closest('tr').style.backgroundColor = ''}
              >
                <td onClick={(e) => e.stopPropagation()}>
                  <input 
                    type="checkbox" 
                    checked={selectedIds.includes(item.id)}
                    onChange={(e) => handleCheckboxChange(e, item.id)}
                  />
                </td>
                <td>{item.terminalDr}</td>
                <td>{item.terminalEx}</td>
                <td>{item.postcode}</td>
                <td>{item.type}</td>
                <td>{item.province}</td>
                <td>{item.cityName}</td>
                <td>{item.streetName}</td>
                <td>{item.number}</td>
                <td>{item.numberInt}</td>
                <td>{item.buildingType}</td>
                <td>{item.exPn}</td>
                <td>{item.drPn}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="13" className="text-center">
                Brak danych
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default AddressesTable;